// extracted by mini-css-extract-plugin
export var item = "languageSwitch-module--item--jAuFw";
export var active_link = "languageSwitch-module--active_link--CIGH0";
export var link = "languageSwitch-module--link--4WtrK";
export var dropdown = "languageSwitch-module--dropdown--mi7DT";
export var active = "languageSwitch-module--active--VVQ+M";
export var dropdown_menu = "languageSwitch-module--dropdown_menu--If8BK";
export var dropdown_item = "languageSwitch-module--dropdown_item--H+WyO";
export var btn = "languageSwitch-module--btn--j5Lic";
export var btn_active = "languageSwitch-module--btn_active--IzTFW";